module.exports = __webpack_public_path__ + "img/2.a74f98c8.png";